import React, { useState, useEffect } from "react";
import ImageUploader from "./components/ImageUploader";
import MarkerCanvas from "./components/MarkerCanvas";
// import MarkerList from "./components/MarkerList";
import CameraCapture from "./components/CameraCapture";
import UploadButton from "./components/UploadButton";
import HomePage from "./components/HomePage";
import SettingsPage from "./components/SettingsPage";
import LoginPage from "./components/LoginPage";
import AddCar from "./components/AddCar";
import CarList from "./components/CarList";
import BackButton from "./components/BackButton";
import "./App.css";

function App() {
  const [imageUrl, setImageUrl] = useState(null); // State für Bild
  const [markers, setMarkers] = useState([]); // State für erkannte Marker
  const [showCamera, setShowCamera] = useState(false); // State für Kamera-Ansicht
  const [showScanner, setShowScanner] = useState(false); // State für Scanner-Seite
  const [showSettings, setShowSettings] = useState(false); // State für Settings-Seite
  const [showLogin, setShowLogin] = useState(false); // State für Login-Modal
  const [isAuthenticated, setIsAuthenticated] = useState(false); // State für Authentifizierung
  const [showAddCar, setShowAddCar] = useState(false); // State für AddCar-Seite
  const [showCar, setShowCar] = useState(false); // State für AddCar-Seite
  const [vehicleName, setVehicleName] = useState(""); // State für Fahrzeugname
  const [createdBy, setCreatedBy] = useState(""); // State für Ersteller (optional)
  const [uploadSuccess, setUploadSuccess] = useState(false); // State für erfolgreichen Upload
  const [warpedImageData, setWarpedImageData] = useState(null); // State für verarbeitetes Bild
  const [vehicleID, setVehicleID] = useState(null); // State für Vehicle ID
  const [savedHost, setSavedHost] = useState(() => {
    // Prefer explicit local override, then build-time env, then same-origin.
    const rawHost =
      localStorage.getItem("backendHost") ||
      import.meta.env.VITE_DEFAULT_HOST ||
      window.location.origin;

    // Remove one or more trailing slashes
    return rawHost.replace(/\/+$/, "");
  });

  const handleLogout = async () => {
    // Nur Backend aufrufen wenn wirklich eingeloggt
    if (isAuthenticated) {
      try {
        await fetch(`${savedHost}/api/auth/logout`, {
          method: "POST",
          credentials: "include",
        });
      } catch (err) {
        console.error("[AUTH] Logout fehlgeschlagen:", err);
      }
    }

    // State immer zurücksetzen
    setIsAuthenticated(false);
    setShowSettings(false);
    setShowAddCar(false);
    setShowCar(false);
  };

  const handleCameraCapture = (capturedImageUrl) => {
    setImageUrl(capturedImageUrl);
    setShowCamera(false);
  };

  const handleCameraClose = () => {
    setShowCamera(false);
  };

  // If not on scanner page, show home page
  if (!showScanner) {
    return <HomePage onStartScanning={() => setShowScanner(true)} />;
  }

  // If AddCar page is requested, show it with header
  if (showAddCar && isAuthenticated) {
    return (
      <div className="app-container">
        <div className="header">
          <div className="header-content">
            <BackButton
              onClick={() => {
                setShowAddCar(false);
                setShowSettings(true);
              }}
            />

            <h1 className="header-title">Fahrzeug hinzufügen</h1>

            <div className="header-spacer"></div>
          </div>
        </div>

        <AddCar />
      </div>
    );
  }

  if (showCar && isAuthenticated) {
    return (
      <div className="app-container">
        <div className="header">
          <div className="header-content">
            <BackButton
              onClick={() => {
                setShowCar(false);
                setShowSettings(true);
              }}
            />

            <h1 className="header-title">Fahrzeug hinzufügen</h1>

            <div className="header-spacer"></div>
          </div>
        </div>

        <CarList savedHost={savedHost} onAuthError={handleLogout} />
      </div>
    );
  }

  // If settings page is requested and user is authenticated, show it with header
  if (showSettings && isAuthenticated) {
    return (
      <div className="app-container">
        <div className="header">
          <div className="header-content">
            <BackButton onClick={() => setShowSettings(false)} />

            <h1 className="header-title">Einstellungen</h1>

            <div className="header-spacer"></div>
          </div>
        </div>

        <SettingsPage
          savedHost={savedHost}
          onAddCar={() => {
            setShowSettings(false);
            setShowAddCar(true);
          }}
          onShowCars={() => {
            setShowSettings(false);
            setShowCar(true);
          }}
          onLogout={handleLogout}
        />
      </div>
    );
  }

  return (
    <div className="app-container">
      <div className="header">
        <div className="header-content">
          <BackButton
            onClick={() => {
              if (uploadSuccess) {
                // Von Namenseingabe zurück zur Upload-Seite
                setUploadSuccess(false);
                setWarpedImageData(null);
                setVehicleID(null);
                setVehicleName("");
                setCreatedBy("");
              } else {
                // Von Upload-Seite zurück zur HomePage
                setShowScanner(false);
                setImageUrl(null);
                setMarkers([]);
              }
            }}
          />

          <h1 className="header-title">Car Scanner</h1>

          
        </div>
      </div>

      <div className="main-content">
        {/* Bild auswählen - immer als erstes */}
        {!uploadSuccess && (
          <div className="card">
            <h3 className="card-title">Bild auswählen</h3>

            <div className="button-container">
              <button
                className="btn-primary"
                onClick={() => setShowCamera(true)}
              >
                Kamera öffnen
              </button>

              <div className="button-wrapper">
                <ImageUploader setImageUrl={setImageUrl} />
              </div>
            </div>
          </div>
        )}

        {/* Marker Canvas mit Weiter-Button */}
        {imageUrl && !uploadSuccess && (
          <>
            <div className="card">
              <MarkerCanvas
                imageUrl={imageUrl}
                onMarkersDetected={setMarkers}
                onImageClear={() => setImageUrl(null)}
                savedHost={savedHost}
                onContinue={(warpedImage, vehID) => {
                  setWarpedImageData(warpedImage);
                  setVehicleID(vehID);
                }}
              />
            </div>

            {/* Weiter Button außerhalb der Card */}
            <div className="action-button-container">
              <button
                onClick={() => {
                  if (warpedImageData) {
                    setUploadSuccess(true);
                  }
                }}
                disabled={!warpedImageData}
                className={`btn-action ${
                  warpedImageData ? "btn-action-primary" : "btn-action-disabled"
                }`}
              >
                Weiter
              </button>
            </div>
          </>
        )}

        {/* Namenseingabe nach erfolgreichem Upload */}
        {uploadSuccess && (
          <>
            <div className="card">
              <h3 className="card-title">Fahrzeugdaten eingeben</h3>

              <div className="form-group">
                <label className="form-label">Wie soll dein Auto heißen? *</label>
                <input
                  type="text"
                  value={vehicleName}
                  onChange={(e) => setVehicleName(e.target.value)}
                  placeholder="z.B. Max Mustermanns Auto"
                  className="form-input"
                />
              </div>

              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">
                  Wie ist dein Name?{" "}
                  <span className="form-label-optional">(optional)</span>
                </label>
                <input
                  type="text"
                  value={createdBy}
                  onChange={(e) => setCreatedBy(e.target.value)}
                  placeholder="z.B. Max Mustermann"
                  className="form-input"
                />
              </div>
            </div>

            {/* Fertigstellen Button */}
            <UploadButton
              warpedImage={warpedImageData}
              vehicleID={vehicleID}
              name={vehicleName}
              createdBy={createdBy}
              savedHost={savedHost}
              onUploadSuccess={() => {
                // Reset für neuen Durchlauf
                setUploadSuccess(false);
                setImageUrl(null);
                setVehicleName("");
                setCreatedBy("");
                setWarpedImageData(null);
                setVehicleID(null);
              }}
            />
          </>
        )}
      </div>

      {/* Kamera-Ansicht (Modal) */}
      {showCamera && (
        <CameraCapture
          onCapture={handleCameraCapture}
          onClose={handleCameraClose}
        />
      )}

      {/* Login Modal */}
      {showLogin && (
        <LoginPage
          onLoginSuccess={() => {
            setIsAuthenticated(true);
            setShowLogin(false);
            setShowSettings(true);
          }}
          onClose={() => setShowLogin(false)}
        />
      )}
    </div>
  );
}

export default App;
